import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LabeledText from 'commons/src/components/LabeledText';
import { BuildingType } from 'commons/src/models/commonTypeScript';
import { ReportSectionWrapper } from '../../../../../components/wrappers';
import { Store } from '../../../../../reducers';
import OpeningHours from '../../../reportSelector/OpeningHoursTable';
import styles from '../../iaqInsight2.module.scss';

export type BuildingDetailsProps = {
    building: BuildingType;
};

const BuildingDetails: React.FC<BuildingDetailsProps> = ({ building }) => {
    const { t: txt } = useTranslation();
    const { dateFormat } = useSelector((state: Store) => state.userSettings);

    return (
        <>
            <ReportSectionWrapper className={styles.buildingInfoWrapper}>
                <div className={styles.formFieldMediumSlim}>
                    <LabeledText
                        label="BuildingType"
                        id="buildingType"
                        value={
                            (building &&
                                building.buildingType &&
                                txt(`BuildingTypeOptions.${building.buildingType.toString()}`)) ||
                            '-'
                        }
                    />
                </div>
                <div className={styles.formFieldMediumSlim}>
                    <LabeledText
                        label="BuildingYear"
                        id="buildingYear"
                        value={(building && building.buildingYear && building.buildingYear.toString()) || '-'}
                    />
                </div>
                <div className={styles.formFieldMediumSlim}>
                    <LabeledText
                        label="Ventilation"
                        id="ventilation"
                        value={
                            (building &&
                                building.ventilationType &&
                                txt(`VentilationTypeOptions.${building.ventilationType.toString()}`)) ||
                            '-'
                        }
                    />
                </div>
                <div className={styles.formFieldMediumSlim}>
                    <LabeledText
                        label="NumberOfFloors"
                        id="numberOfFloors"
                        value={(building && building.floors && building.floors.toString()) || '-'}
                    />
                </div>
            </ReportSectionWrapper>
            <div className={styles.openingHoursWrapper}>
                <OpeningHours
                    optionalBuildingProps={['openingHours']}
                    dateFormat={dateFormat}
                    validate={false}
                    building={building}
                />
            </div>
        </>
    );
};

export default BuildingDetails;
